import { useState } from 'react';
import { formatCurrencyCompact, formatCurrencyFull } from '@/utils/formatters';

export function CurrencyAmount({
  value,
  className = '',
  compact = true,
}: {
  value: number;
  className?: string;
  compact?: boolean;
}) {
  const [expanded, setExpanded] = useState(false);
  const full = formatCurrencyFull(value);

  return (
    <span className="relative inline-flex max-w-full justify-center">
      <button
        type="button"
        onClick={() => setExpanded((current) => !current)}
        className={`max-w-full cursor-help rounded-md text-safe-normal underline decoration-dotted decoration-current/35 underline-offset-4 ${className}`}
        aria-label={`${compact ? formatCurrencyCompact(value) : full}. Bấm để xem số tiền đầy đủ`}
        aria-expanded={expanded}
        title={full}
      >
        {compact ? formatCurrencyCompact(value) : full}
      </button>
      {expanded && (
        <span className="absolute bottom-full left-1/2 z-[95] mb-2 -translate-x-1/2 whitespace-nowrap rounded-xl bg-slate-900 px-3 py-2 text-[11px] font-semibold text-white shadow-xl animate-modal-fade">
          {full}
          <span className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 -translate-y-1 rotate-45 bg-slate-900" />
        </span>
      )}
    </span>
  );
}
